import React from 'react'
import s from './MyPopupTransactionRejected.module.css'
import {useNavigate} from "react-router-dom";
import {userSlice} from "../../../store/reducers/UserSlice";
import {useAppDispatch} from "../../../hooks/redux";
import failed from "../../../assets/img/failed_circle.png";
import CustomBtnPink from "../customBtnPink/CustomBtnPink";
import CustomBtnTransparentPersonalAccount
    from "../customBtnTransparentPersonalAccount/CustomBtnTransparentPersonalAccount";
import {STATEMENT} from "../../../router/Constants";

const MyPopupTransactionRejected = () => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const closePopup = () => {
        dispatch(userSlice.actions.setTransactionWasSendSuccess(null))
    }

    const closeAndRedirect = () => {
        dispatch(userSlice.actions.setTransactionWasSendSuccess(null))
        navigate(STATEMENT)
    }

    return (
        <div className={s.wrapper}>
            <div className={s.content}>
                <img src={failed} alt=""/>
                <div className={s.title}>
                    Failed
                </div>
                <div className={s.subtitle}>
                    Your request was rejected. Please try again
                </div>
                <div className={s.btns_block}>
                    <div className={s.btn_wrapper}>
                        <CustomBtnPink title={"Try Again"} onClick={() => closePopup()}/>
                    </div>
                    <div className={s.btn_wrapper}>
                        <CustomBtnTransparentPersonalAccount title={"Go to Statements"} onClick={() => closeAndRedirect()}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyPopupTransactionRejected;
